import { z } from 'zod';

/**
 * Published when a member confirms their own grant (IMM-436.2). Informational
 * today — no consumer in this release; it exists so the grant is on the bus for
 * the audit surface and for later slices that react to activation.
 */
export const SkillInstanceGrantedPayloadSchema = z.object({
  instanceId: z.uuid(),
  workspaceId: z.uuid(),
  definitionId: z.uuid(),
  grantingMemberId: z.uuid(),
  grantedAt: z.iso.datetime(),
});

export type SkillInstanceGrantedPayload = z.infer<typeof SkillInstanceGrantedPayloadSchema>;

/**
 * Published when a grant is revoked (IMM-436.2). The seam that lets revocation
 * reach the slices that own the things it must stop: IMM-436.5 voids pending
 * proposed actions, IMM-436.3 cancels a queued run. Publishing rather than
 * reaching into their tables is what keeps this slice from depending forward on
 * either of them.
 */
export const SkillInstanceRevokedPayloadSchema = z.object({
  instanceId: z.uuid(),
  workspaceId: z.uuid(),
  grantingMemberId: z.uuid(),
  revokedAt: z.iso.datetime(),
});

export type SkillInstanceRevokedPayload = z.infer<typeof SkillInstanceRevokedPayloadSchema>;
